import { initializeApp } from 'firebase/app';

export const environment = {
    production: false,
    firebaseConfig: {
      apiKey: "AIzaSyCBcIwxKU-Jvue5YNA2USpWl70sgICmmWE",
      authDomain: "welaraoperatingsystem-adc50.firebaseapp.com",
      projectId: "welaraoperatingsystem-adc50",
      storageBucket: "welaraoperatingsystem-adc50.firebasestorage.app",
      messagingSenderId: "502375324985",
      appId: "1:502375324985:web:8c05a625c49b98b50f9ce8",
      measurementId: "G-JG6WRTTRQ9"
  }
};

const isprod = window.location.href.indexOf('welara.com');
const isuat = window.location.href.indexOf('https://uat-');

export const environmentConfig = {
  apiBaseUrl: (isprod > -1 && isuat == -1) ? 'https://api.welara.com' :
              (isuat > -1) ? 'https://uat-api.welara.com' :
              'https://localhost:44396',
  apiAuthBaseUrl: (isprod > -1 && isuat == -1) ? 'https://api2.welara.com' :
                  (isuat > -1) ? 'https://uat-api2.welara.com' :
                  'https://localhost:7000',
  reportingUrl: (isprod > -1 && isuat == -1) ? 'https://reporting.welara.com/hourglass_weekly.aspx' :
                'https://uat-reporting.welara.com/hourglass_weekly.aspx',
  environment: (isprod > -1 && isuat == -1) ? 'production' :
               (isuat > -1) ? 'UAT' :
                'local',
  version: '04.00.11',
  releaseDate: '29.04.2026'
};

const app = initializeApp(environment.firebaseConfig);
